<template>
  <div class="ma-10">
    <v-dialog
      v-model="showCategoryPopup"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title class="modal-title">
          Pilih Kategori
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="category in listCategory"
              :key="category.value"
              @click="selectCategory(category.value)"
              :class="{ 'selected-category': filter.category === category.value }"
            >
              <v-list-item-title>{{ category.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#3b54d9"
            text
            @click="clearCategory"
          >
            Clear Filter
          </v-btn>
          <v-btn
            color="#3b54d9"
            text
            @click="showCategoryPopup = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />
    <div class="top-container-box">
      <h1>Testimoni</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Buat Testimoni"
          style="background-color: #3b54d9; color: #ffffff; width: 250px"
          @click="() => $router.push('/testimoni/new')"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="6">
        <div class="action-head">
          <div class="f-search">
            <div>
              <v-text-field
                v-model="filter.name"
                type="text"
                class="f-input"
                placeholder="Search..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="() => getTestimoni()"
              ></v-text-field>
            </div>
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
          <v-btn
            class="ml-4"
            color="#3b54d9"
            style="color: #ffffff; border-radius: 10px"
            @click="showCategoryPopup = true"
          >
            Filter Kategori
          </v-btn>
        </div>
      </v-col>
    </v-row>
    
    <NewTable
      :headers="headers"
      :rows="testimonies"
      :currentPage="currentPage"
      :totalPages="totalPage"
      :totalData="total"
      :customColumns="customColumns"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getTestimoni"
    />
  </div>
</template>

<script>
import Button from "../../../components/Button.vue";
import Loading from "@/components/ilustration/Loading.vue";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";
import getAuthentification from "@/utils/badrequest.js";

export default {
  name: "Testimoni",
  components: {
    Button,
    Loading,
    Popup,
    NewTable,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      perPage: 10,
      totalPage: 0,
      message: "",
      isPopup: false,
      showCategoryPopup: false,
      filter: {
        name:"",
        sort_by: "desc",
        category: "",
      },
      listCategory: [
        {
          name: "Prakerja",
          value: "PRAKERJA",
        },
        {
          name: "Kampus Merdeka",
          value: "KAMPUS_MERDEKA",
        },
        {
          name: "Corporate",
          value: "CORPORATE",
        },
        {
          name: "Acceleration",
          value: "ACCELERATION",
        },
        {
          name: "Training",
          value: "TRAINING",
        },
        {
          name: "Collaboration",
          value: "COLLABORATION",
        },
        {
          name: "Talent as a Service",
          value: "TALENT_SERVICE",
        },
      ],
      headers: [
        {
          text: "NAMA",
          field: "name",
          width: 280,
        },
        {
          text: "UNIVERSITAS",
          field: "place",
          width: 300,
        },
        {
          text: "MAJOR",
          field: "job",
          width: 200,
        },
        {
          text: "KATEGORI",
          field: "category",
          width: 200,
        },
        {
          text: "STATUS",
          field: "is_active",
          width: 100,
        },
      ],
      testimonies: [],
      customColumns: [
        {
          field: "is_active",
          render: (row) => {
            return `<span style="color: ${row.is_active ? 'green' : 'red'}">${row.is_active ? 'Aktif' : 'Non Aktif'}</span>`;
          },
        },
      ],
    };
  },
  methods: {
    async getTestimoni(page) {
      if (!page) page = this.currentPage;
      else this.currentPage = page;

      this.isLoading = true;
      try {
        const response = await this.$crm_http.get(
          `/v1/testimony?page=${page}&per_page=${this.perPage}&sort_by=${this.filter.sort_by}&category=${this.filter.category || ""}&name=${this.filter.name || ""}`
        );
        const res = response.data.data.testimonies || [];
        this.testimonies = res.map((item) => ({
          id: item.id,
          name: item.name,
          place: item.place,
          job: item.job,
          category: item.category,
          is_active: item.is_active,
        }));
        const t = parseInt(response.data.data.total);
        this.total = t;
        this.totalPage = Math.ceil(t / this.perPage) || 1;
        if (this.currentPage > this.totalPage) {
          this.currentPage = this.totalPage;
          this.getTestimoni();
        }
      } catch (err) {
        this.message = err.response.data.data;
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    watchItem(id) {
      this.$router.push("/testimoni/watch/" + id);
    },
    editItem(id) {
      this.$router.push("/testimoni/edit/" + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$crm_http.delete("/v1/testimony/" + id);
        this.getTestimoni();
      } catch (err) {
        this.message = err.response.data.data;
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },

    updateIsFilterActive() {
      this.isFilterActive = !(
        this.filter.sort_by === "desc" &&
        !this.filter.name &&
        !this.filter.category
      );
    },
    selectCategory(value) {
      this.filter.category = value;
      this.showCategoryPopup = false;
      this.getTestimoni();
      this.updateIsFilterActive();
    },
    clearCategory() {
      this.filter.category = "";
      this.showCategoryPopup = false;
      this.getTestimoni();
      this.updateIsFilterActive();
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getTestimoni();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title {
  font-weight: bold;
  font-size: 19px;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
.selected-category {
  background-color: #e3f2fd;
  color: #3b54d9;
}
</style>